module.exports = __webpack_public_path__ + "static/media/share.e7b143c0.svg";